/**
 * Etiquetas visibles de métodos de pago (UI).
 * Valores internos (mercadopago, MercadoPago, mp) no se modifican.
 * @module utils/metodoPagoLabels
 */

export const BILLETERA_VIRTUAL_LABEL = 'Billetera virtual';
export const COBRO_BILLETERA_VIRTUAL_LABEL = 'Cobro billetera virtual';

const KNOWN_LABELS = {
  efectivo: 'Efectivo',
  tarjeta: 'Tarjeta',
  transferencia: 'Transferencia',
  credito: 'Crédito',
  crédito: 'Crédito',
  debito: 'Débito',
  cheque: 'Cheque',
  pendiente: 'Pendiente'
};

export function isBilleteraVirtualMetodo(metodo) {
  const raw = String(metodo || '').trim().toLowerCase();
  if (!raw) return false;
  const compact = raw.replace(/[\s_-]+/g, '');
  return compact === 'mercadopago' || compact === 'mp' || raw === 'mercado pago';
}

/**
 * @param {string} metodo — valor interno (mercadopago, MercadoPago, mp, …)
 * @param {{ uppercase?: boolean }} [opts]
 */
export function formatMetodoPagoLabel(metodo, opts = {}) {
  const { uppercase = false } = opts;
  if (isBilleteraVirtualMetodo(metodo)) {
    return uppercase ? BILLETERA_VIRTUAL_LABEL.toUpperCase() : BILLETERA_VIRTUAL_LABEL;
  }
  const key = String(metodo || '').trim().toLowerCase();
  const label = KNOWN_LABELS[key]
    || (metodo
      ? String(metodo).charAt(0).toUpperCase() + String(metodo).slice(1)
      : '—');
  return uppercase ? label.toUpperCase() : label;
}
